import { CheckoutState } from '../../state';
import {
    getCanMakePaymentsWithGooglePay,
    isGooglePayScriptLoaded,
} from './pureSelectors';

export const isGooglePayLoadedAndCanMakePayments = (state: CheckoutState) =>
    isGooglePayScriptLoaded(state) && getCanMakePaymentsWithGooglePay(state);
